import React from 'react';

import { Label } from '../../components';
import { commQualities, getLastCommQuality } from '../../../common/utils/vending-utils';
import { DEFAULT_LAST_COMM_THRESHOLDS } from '../../../common/constants';
import { useUserContext } from '../../../common/utils';
import { formatDate } from '../../../common/utils/utils';

const MachineCommunication = ({ communication, noQuality }) => {
	const { tenantSettings } = useUserContext();
	const [minThreshold, maxThreshold] = Array.isArray(tenantSettings?.lastCommThresholds)
		? tenantSettings.lastCommThresholds
		: DEFAULT_LAST_COMM_THRESHOLDS;

	// NoQuality shows a version that does not colorize the communication based on quality
	const communicationQuality = noQuality ? null : getLastCommQuality({ communication, minThreshold, maxThreshold });

	return (
		<Label
			red={communication && communicationQuality === commQualities.BAD}
			green={communicationQuality === commQualities.GOOD}
			yellow={communicationQuality === commQualities.OKAY}
			label={communication ? formatDate(communication, 'DAY_MONTHWORD_YEAR_HOUR_MINUTE_AMPM') : 'No comms'}
		/>
	);
};

export default React.memo(MachineCommunication);
